// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"recycling-reports_routeHeader_3nkld","addButton":"recycling-reports_addButton_YZ07L"};